import authentication from "@irati/auth"
import {getPaymentMethods} from "@irati/payments/services/Payments"
import {PaymentMethodType} from "@irati/types"

export enum PaymentOptions {
  ApplePay = "applepay",
  GooglePay = "googlepay",
  Mastercard = "mc",
  Visa = "visa",
  Paypal = "paypal",
  Ideal = "ideal",
  Maestro = "maestro",
  Bancontact = "bancontact"
}

export type PaymentAvailability = {[key in PaymentOptions]?: boolean}

export async function getPaymentOptions(currency: string): Promise<PaymentAvailability> {
  const getPaymentMethodsPayload = {
    locale: authentication.userLocale(),
    amount: 10, // Hardcoded value
    currency
  }
  return getPaymentMethods(getPaymentMethodsPayload).then(
    (methods): PaymentAvailability => ({
      [PaymentOptions.ApplePay]: !!methods.find((method) => method.type === PaymentMethodType.Applepay),
      [PaymentOptions.GooglePay]: !!methods.find((method) => method.type === PaymentMethodType.Googlepay),
      [PaymentOptions.Mastercard]: !!methods.find((method) => method.brands?.includes("mc")),
      [PaymentOptions.Visa]: !!methods.find((method) => method.brands?.includes("visa")),
      [PaymentOptions.Maestro]: !!methods.find((method) => method.brands?.includes("maestro")),
      [PaymentOptions.Paypal]: !!methods.find((method) => method.type === PaymentMethodType.Paypal),
      [PaymentOptions.Ideal]: !!methods.find((method) => method.type === PaymentMethodType.Ideal),
      [PaymentOptions.Bancontact]: !!methods.find((method) => method.type === PaymentMethodType.Bcmc)
    })
  )
}
